import { render } from "./OldIndex.vue?vue&type=template&id=582a7897"
import script from "./OldIndex.vue?vue&type=script&lang=js"
export * from "./OldIndex.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akosipau/Dropbox/Sites/onboarding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__